import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

/**
 *
 * DashboardRedirect
 *
 * Sends the old organization-scoped dashboards to the single portal dashboard.
 *
 * `/organization/:orgId/dashboard` and `/exhibitor/:orgId/dashboard` were the same page
 * before EXEC-1550 merged them, and licence emails still link to the latter, so those
 * paths have to keep resolving. The search string carries over because those emails
 * append `?onboarding=<eventId>`, which the dashboard reads to resume onboarding.
 */
const DashboardRedirect = () => {
  const location = useLocation()

  return <Navigate to={{ pathname: '/dashboard', search: location.search }} replace />
}

export default DashboardRedirect
